module.exports = __webpack_public_path__ + "static/media/zocalo7.4cbff259.jpg";